"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use CreditCard from foundation/CreditCard
 * @trackcomponent
 */
export const CreditCard = createSVGIcon(
  <>
    <path
      stroke="currentColor"
      d="M20.778 15.566l10.1 10.1-7.212 7.213-10.1-10.1z"
      strokeWidth="0.7"
    />
    <path fill="currentColor" d="M18.76 18l9.413 9.413-.761.761-9.413-9.412z" />
    <path
      stroke="currentColor"
      d="M18.4 24.4h16.2v10.2H18.4z"
      fill="#FFF"
      strokeWidth="0.7"
    />
    <path
      stroke="currentColor"
      d="M20.4 26.4h3.2v3.2h-3.2z"
      strokeWidth="0.7"
    />
  </>,
  "CreditCard",
  { viewBox: "13 15 22 20", titleAccess: "CreditCard", fill: "none" }
);
